import { Box } from '@mui/material';
import { grey } from '@mui/material/colors';
import React from 'react';
import { Icons } from '../icons/Icons';

export default function FormPanel({
    Icon = undefined,
    bottomBorder = false,
    children,
    sx = {},
    emptyIcon = false,
    ...rest
}) {
    return (
        <Box
            className="_formPanel"
            sx={[
                {
                    px: 2.5,
                    py: 3,
                    display: 'flex',
                    flexDirection: 'row',
                    borderBottom: bottomBorder ? 1 : 'none',
                    borderColor: grey['800'],
                    borderRadius: 1,
                    width: '100%'
                },
                sx
            ]}
            {...rest}
        >
            {Icon ? (
                <Box sx={{ flexGrow: 0, alignSelf: 'center' }}>
                    <Icon size="large" color="disabled" />
                </Box>
            ) : (
                emptyIcon && (
                    <Box sx={{ flexGrow: 0, alignSelf: 'center' }}>
                        <Icons.Abc sx={{ visibility: 'hidden' }} color="disabled" />
                    </Box>
                )
            )}
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, flexGrow: 2, width: '100%' }}>{children}</Box>
        </Box>
    );
}
